// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"tooltip-module__tooltip___2I3eM"};